/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createReservation = /* GraphQL */ `mutation CreateReservation($appointmentData: String!) {
  createReservation(appointmentData: $appointmentData) {
    success
    paypayUrl
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReservationMutationVariables,
  APITypes.CreateReservationMutation
>;
export const deleteReservation = /* GraphQL */ `mutation DeleteReservation($ReservationHash: String!) {
  deleteReservation(ReservationHash: $ReservationHash) {
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReservationMutationVariables,
  APITypes.DeleteReservationMutation
>;
export const createPatientCard = /* GraphQL */ `mutation CreatePatientCard(
  $hospitalName: String!
  $patientCardNumber: String!
  $patientBirth: String!
  $nickname: String
) {
  createPatientCard(
    hospitalName: $hospitalName
    patientCardNumber: $patientCardNumber
    patientBirth: $patientBirth
    nickname: $nickname
  ) {
    success
    card {
      cardId
      hospitalName
      patientCardNumber
      patientBirth
      nickname
      createdAt
      __typename
    }
    cards {
      cardId
      hospitalName
      patientCardNumber
      patientBirth
      nickname
      createdAt
      __typename
    }
    message
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePatientCardMutationVariables,
  APITypes.CreatePatientCardMutation
>;
export const updatePatientCard = /* GraphQL */ `mutation UpdatePatientCard(
  $cardId: String!
  $nickname: String
  $patientCardNumber: String
  $patientBirth: String
) {
  updatePatientCard(
    cardId: $cardId
    nickname: $nickname
    patientCardNumber: $patientCardNumber
    patientBirth: $patientBirth
  ) {
    success
    card {
      cardId
      hospitalName
      patientCardNumber
      patientBirth
      nickname
      createdAt
      __typename
    }
    cards {
      cardId
      hospitalName
      patientCardNumber
      patientBirth
      nickname
      createdAt
      __typename
    }
    message
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePatientCardMutationVariables,
  APITypes.UpdatePatientCardMutation
>;
export const deletePatientCard = /* GraphQL */ `mutation DeletePatientCard($cardId: String!) {
  deletePatientCard(cardId: $cardId) {
    success
    card {
      cardId
      hospitalName
      patientCardNumber
      patientBirth
      nickname
      createdAt
      __typename
    }
    cards {
      cardId
      hospitalName
      patientCardNumber
      patientBirth
      nickname
      createdAt
      __typename
    }
    message
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePatientCardMutationVariables,
  APITypes.DeletePatientCardMutation
>;
